import { render } from "./AllPermitsMenuWithLls.vue?vue&type=template&id=28a84241"
import script from "./AllPermitsMenuWithLls.vue?vue&type=script&lang=js"
export * from "./AllPermitsMenuWithLls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__